/* @flow */
import * as React from "react";
import { withColorsProvider, type ColorSet } from "../ColorsProvider";
import type { StylesObject } from "nx-components/utils/prefixStyles";

type Props = {
  colors: ColorSet,
  style?: ?StylesObject,
};

class Divider extends React.Component<Props> {
  render() {
    const { colors, style } = this.props;

    return (
      <hr
        style={{
          margin: 0,
          height: 1,
          border: "none",
          backgroundColor: colors.DIVIDER,
          ...style,
        }}
        aria-hidden
      />
    );
  }
}

export default withColorsProvider(Divider);



// WEBPACK FOOTER //
// ../nx-components/src/ItemList/Divider.jsx